import { render, staticRenderFns } from "./ExpcD_Details.vue?vue&type=template&id=a033ce1a"
import script from "./ExpcD_Details.vue?vue&type=script&lang=js"
export * from "./ExpcD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports